// extracted by mini-css-extract-plugin
export default {"access-product-link":"the-view_access-product-link__rB5TL","link-label":"the-view_link-label__u6kKh"};